// 「周辺」用の変換処理
export const convertFromRecommendation = (
  masterBookSets,
  recommendationsMasterBooks
) => {
  // APIまだでmasterBookSetsが空の場合は、空配列を返す
  if (masterBookSets.length == 0) return [];

  // 全masterBookSetsから、周辺の対象チケットのみを抽出して変換する
  const uniqueMasterBookSetIdList = makeUniqueMasterBookSetIdList(
    recommendationsMasterBooks
  );
  return masterBookSets.filter((masterBookSet) =>
    uniqueMasterBookSetIdList.includes(masterBookSet.id)
  );
};

const makeUniqueMasterBookSetIdList = (masterBooks) => {
  let uniqueMasterBookSetIdList = [];
  masterBooks.forEach((masterBook) => {
    const setId = masterBook.master_book_set_id;
    if (setId && !uniqueMasterBookSetIdList.includes(setId)) {
      uniqueMasterBookSetIdList.push(setId);
    }
  });
  return uniqueMasterBookSetIdList;
};
